import Sidebar, { MobileTopbar } from "./Sidebar";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-grid-teal bg-[#F6FAF9]">
      <Sidebar />
      <MobileTopbar />
      <main className="lg:mr-72 min-h-screen p-4 sm:p-6 lg:p-8 fade-in" data-testid="main-content">
        {children}
      </main>
      <Toaster richColors position="top-center" dir="rtl" />
    </div>
  );
}
